import { Box, Button, Typography } from "@mui/material";
import { useAppDispatch } from "../../../Redux/store";
import { setActiveStep } from "../../../Redux/slices/JobPostCreationSlice";
import { setJobPostingModalOpen } from "../../../Redux/slices/JobPostingCreationSlice";

const IntroStep = () => {
  const dispatch = useAppDispatch();

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="60vh">
      <Typography variant="h3" align="center" fontWeight={600} mb={2}>
        Let's Find Your<br />Perfect Match!
      </Typography>
      <Typography variant="body1" color="text.secondary" mb={4} align="center">
        Harness the power of AI to craft a compelling job post in minutes
      </Typography>
      <Button 
        variant="contained" 
        color="primary" 
        size="large" 
        fullWidth 
        sx={{ maxWidth: 320, mb: 1 }} 
        onClick={() => dispatch(setActiveStep(1))}
      >
        Let AI Help Me Write It
      </Button>
      <Button 
        variant="text" 
        color="primary" 
        fullWidth 
        sx={{ maxWidth: 320, mb: 4 }} 
        onClick={() => dispatch(setJobPostingModalOpen(true))}
      >
        I'll Write It Myself
      </Button>
    </Box>
  );
};

export default IntroStep; 